import moment from 'moment'

export default {
  methods: {
    cs (str){
      if (str) {
        return str.trim().replace(/'/g, ' ').replace(/"/g, " ").replace(/\t/g, ' ')
      } else {
        return str
      }      
    },
    formatMoney (amount){
      try {
        if (amount) {
          const negativeSign = amount < 0 ? "-" : "";
          let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(2)).toString();
          let j = (i.length > 3) ? i.length % 3 : 0;
          return negativeSign + (j ? i.substr(0, j) + "," : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") + (2 ? "." + Math.abs(amount - i).toFixed(2).slice(2) : "");
        } else {
          return "0.00"
        }
      } catch (error) {
        return "0.00"
      }    
    },
    searchFunction ({ v2_empresa_id, action, searchQuery, app_value, app_entity, app_method, callback }) {
      try {

        console.log("searchFunction");
        console.log("v2_empresa_id: ", v2_empresa_id);
        console.log("action: ", action);
        console.log("searchQuery: ", searchQuery);
        console.log("app_value: ", app_value);
        console.log("app_entity: ", app_entity);
        console.log("app_method: ", app_method);

        var items = []

        if (action === "ASYNC_SEARCH" && v2_empresa_id != undefined && (app_value == '' || app_value == undefined || searchQuery.length > 0)) { 

          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/'+ app_entity +'/', { params: { type: app_method, searchQuery: searchQuery } })
          .then(response => {
            if (response.data) {  
              items = response.data
            }
            callback(null, items)
          })
          .catch(error => {
            callback(null, items)
            this.showError(error)
          })
        } else if (action === "ASYNC_SEARCH" && v2_empresa_id != undefined && searchQuery.length == 0 && app_value != undefined && app_value != '') {

          if (app_value != undefined) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/'+ app_entity +'/', { params: { type: "getSelectByID", searchQuery: app_value } })
            .then(response => {
              if (response.data) {  
                items = response.data
              }
              callback(null, items)
            })
            .catch(error => {
              callback(null, items)
              this.showError(error)
            })
          } else {
            callback(null, items)
          }
        } else if (action === "ASYNC_SEARCH_NEW" && v2_empresa_id != undefined) {

          if (app_value != undefined) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/'+ app_entity +'/', { params: { type: "getSelectByID", searchQuery: app_value } })
            .then(response => {
              if (response.data) {  
                items = response.data
              }
              callback(null, items)
            })
            .catch(error => {
              callback(null, items)
              this.showError(error)
            })
          } else {
            callback(null, items)
          }
        } else {
          callback(null, items)
        }
      } catch (error) {
        this.showError(error)
      }
    },
    /*searchFunction ({ action, searchQuery, app_value, app_entity, app_method, callback }) {
      try {

        var items = []

        if (action === "ASYNC_SEARCH" && this.v2_empresa_id != undefined && searchQuery.length > 0) { 

          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ this.v2_empresa_id +'/'+ app_entity +'/', { params: { type: app_method, searchQuery: searchQuery } })
          .then(response => {
            if (response.data) {  
              items = response.data
            }
            callback(null, items)
          })
          .catch(error => {
            callback(null, items)
            this.showError(error)
          })
        } else if (action === "ASYNC_SEARCH" && searchQuery.length == 0 && app_value.length > 0) {

          if (app_value != undefined) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ this.v2_empresa_id +'/'+ app_entity +'/', { params: { type: "getSelectByID", searchQuery: app_value } })
            .then(response => {
              if (response.data) {  
                items = response.data
              }
              callback(null, items)
            })
            .catch(error => {
              callback(null, items)
              this.showError(error)
            })
          } else {
            callback(null, items)
          }
        } else {
          callback(null, items)
        }
      } catch (error) {
        this.showError(error)
      }
    },*/
    getIniciales (nombre, apellido) {

      if (nombre != undefined && apellido != undefined) {
        return nombre.substring(0,1) + apellido.substring(0,1);
      } else if (nombre != undefined) {
        var tmp = nombre.split(' ');

        if (tmp.length >= 2) {
          return tmp[0].substring(0,1) + tmp[1].substring(0,1);
        } else if (tmp.length == 1) {
          return tmp[0].substring(0,2);
        } else {
          return '?';
        }

      } else {
        return '?'
      }

    },
    getUserData () {
      var data = []
      try {
        
        return new Promise((resolve, reject) => {
          if (localStorage.signedIn) {
            this.$http.secured.get('/auth/v1/users', { params: { type: "getUserData" } })
              .then(response => {
                data = response.data
                resolve({
                  data
                })
              })
              .catch(error => {
                resolve({
                  data
                })
                console.log(error)
              })          
          } else {
            data = [] 
          }    
        })
      } catch (error) {
        console.log(error)
      }
    },

    getMailboxes () {

      var datos = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          //this.$http.secured.get('/desk/client/v1/v2_emails/', { params: { type: "getMailboxes" } })
          this.$http.secured.get('/desk/client/v1/v2_email_imap_mailbox_temps/', { params: { type: "getMailboxes" } })
            .then(response => {

              datos = response.data

              resolve({
                datos
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                datos
              })
              this.showError(error)
            })  
                    
        })
      } catch (error) {
        this.showError(error)
      }

    },

    getEmails (folder, pagination_top, pagination_bottom, direction) {

      var datos = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          //this.$http.secured.get('/desk/client/v1/v2_emails/', { params: { type: "getEmails", folder: folder, pagination_top: pagination_top, pagination_bottom: pagination_bottom, direction: direction } })
          this.$http.secured.get('/desk/client/v1/v2_email_imap_temps/', { params: { type: "getEmails", folder: folder, pagination_top: pagination_top, pagination_bottom: pagination_bottom, direction: direction } })
            .then(response => {

              datos = response.data

              resolve({
                datos
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                datos
              })
              this.showError(error)
            })  
                    
        })
      } catch (error) {
        this.showError(error)
      }

    },

    getEmailDetail (id) {

      var datos = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          //this.$http.secured.get('/desk/client/v1/v2_emails/', { params: { type: "getEmails", folder: folder, pagination_top: pagination_top, pagination_bottom: pagination_bottom, direction: direction } })
          this.$http.secured.get('/desk/client/v1/v2_email_imap_temps/', { params: { type: "getEmailDetail", id: id } })
            .then(response => {

              datos = response.data

              resolve({
                datos
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                datos
              })
              this.showError(error)
            })  
                    
        })
      } catch (error) {
        this.showError(error)
      }

    },
    
    getEmpresas () {
      var items = []
      try {
        return new Promise((resolve, reject) => {
          if (localStorage.getItem('companies') != undefined) {
            items = JSON.parse(localStorage.getItem('companies'))
            resolve({
              items
            })
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/', { params: { type: "getMisEmpresasSelect" } })
              .then(response => {
                items = response.data
                localStorage.setItem('companies', JSON.stringify(items));
                resolve({
                  items
                })
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          }         
        })
      } catch (error) {
        this.showError(error)
      }
    },

    
    getCasoDocumentoVersiones (v2_empresa_id,documento_id,mostrar_eliminados) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_documento_versiones/', { params: { type: "getCasoDocumentoVersiones", documento_id: documento_id, mostrar_eliminados: mostrar_eliminados } })
              .then(response => {

                var items = response.data
                resolve({
                  items
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },
    
    deleteCasoDocumentoVersiones (v2_empresa_id,documento_version_id) {

      var result = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_documento_versiones/', { params: { type: "deleteCasoDocumentoVersiones", documento_version_id: documento_version_id } })
              .then(response => {

                var result = response.data
                resolve({
                  result
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  result
                })
                this.showError(error)
              })  
          } else {
            resolve({
              result
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },
    
    activateCasoDocumentoVersiones (v2_empresa_id,documento_version_id) {

      var result = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_documento_versiones/', { params: { type: "activateCasoDocumentoVersiones", documento_version_id: documento_version_id } })
              .then(response => {

                var result = response.data
                resolve({
                  result
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  result
                })
                this.showError(error)
              })  
          } else {
            resolve({
              result
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },
    updateCasoDocumentoNombre (v2_empresa_id,documento_version_id,nombre) {

      var result = undefined
      nombre = this.cs(nombre)
      
      try {

        return new Promise((resolve, reject) => {

          //this.updateProgress()

          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_documento_versiones/', { params: { type: "updateCasoDocumentoNombre", documento_version_id: documento_version_id, nombre: nombre } })
            .then(response => {

              result = response

              resolve({
                result
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                result
              })
              this.showError(error)
            })   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },
    
    updateCasoDocumentoDescripcion (v2_empresa_id,documento_version_id,descripcion) {

      var result = undefined
      descripcion = this.cs(descripcion)
      
      try {

        return new Promise((resolve, reject) => {

          //this.updateProgress()

          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_documento_versiones/', { params: { type: "updateCasoDocumentoDescripcion", documento_version_id: documento_version_id, descripcion: descripcion } })
            .then(response => {

              result = response

              resolve({
                result
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                result
              })
              this.showError(error)
            })   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },
    updateCasoDocumento (documento) {

      var result = undefined

      try {

        return new Promise((resolve, reject) => {

          //this.updateProgress()

          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ documento.v2_empresa_id +'/v2_caso_documento_versiones/', { params: { type: "updateCasoDocumento", documento: documento } })
            .then(response => {

              result = response

              resolve({
                result
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                result
              })
              this.showError(error)
            })   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },
    createCasoDocumento (documento) {

      var result = undefined

      try {

        return new Promise((resolve, reject) => {

          //this.updateProgress()

          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ documento.v2_empresa_id +'/v2_caso_documentos/', { params: { type: "createCasoDocumento", documento: documento } })
            .then(response => {

              result = response

              resolve({
                result
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                result
              })
              this.showError(error)
            })   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },
    getCasoDocumentos (v2_empresa_id,caso_id) {

      var items = []

      try {

        return new Promise((resolve, reject) => {

          //this.updateProgress()

          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_documentos/', { params: { type: "getCasoDocumentos", caso_id: caso_id } })
            .then(response => {

              if ( response.data ) {
                items = response.data
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },
    createCasoFolderPath (v2_empresa_id,caso_id) {

      var result = []

      try {

        return new Promise((resolve, reject) => {

          //this.updateProgress()

          this.$http.secured.get('/global/v1/v2_repositorios/', { params: { type: "createCasoFolderPath", caso_id: caso_id, v2_empresa_id: v2_empresa_id } })
            .then(response => {

              if ( response.data ) {
                result = response.data
              }

              resolve({
                result
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                result
              })
              //--this.showError(error)
            })   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getMonedas () {

      var items = []

      try {

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('monedas') != undefined) {

            items = JSON.parse(localStorage.getItem('monedas'))
            resolve({
              items
            }) 
            
          } else {

            //this.updateProgress()

            this.$http.secured.get('/desk/client/v1/v3_monedas/', { params: { type: "getMonedas" } })
              .then(response => {

                if ( response.data ) {
                  response.data.forEach(element => {
                    items.push({ id: element.code, label: element.name })
                  });
                }

                localStorage.setItem('monedas', JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          }   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },
    getMonedasUsadas (v2_empresa_id) {
      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          this.$http.secured.get('/desk/client/v1/v3_monedas/', { params: { type: "getMonedasUsadas", v2_empresa_id: v2_empresa_id } })
            .then(response => {

              if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.code, label: element.name, simbol: element.simbol })
                });
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })  
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* CASOS */

    getCasoForCreate (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getCasoForCreate" } })
            .then(response => {

              if ( response.data ) {

                response.data.forEach(element => {

                  if (element.cs_model == "received_at") { 
                    element.cs_value = this.formatDateForInput(new Date())
                  }

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDatetimeForInput(element.cs_value)
                  }

                  if (element.cs_items != undefined) {

                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }

                  items.push(element)
                });

                //items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasoForUpdate (v2_empresa_id,id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getCasoForUpdate", id: id } })
            .then(response => {

              if ( response.data ) {

                response.data.forEach(element => {

                  if (element.cs_column_name == "tiempo_acumulado") { 
                    element.cs_value = this.formatTimeToSeconds(element.cs_value)    
                  }
                  
                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDateTime(element.cs_value)
                  }

                  if (element.cs_items != undefined) {
                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }
                  
                  items.push(element)
                });

                //items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasoForView (v2_empresa_id,id) {
      var items = []
      var caso = {}
      var has_gd_integration = undefined

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getCasoForView", id: id } })
            .then(response => {

              if ( response.data ) {

                caso = response.data.caso
                has_gd_integration = response.data.has_gd_integration

                response.data.attributes.forEach(element => {

                  if (element.cs_column_name == "tiempo_acumulado") { 
                    element.cs_value = this.formatTimeToSeconds(element.cs_value)    
                  }

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDateTime(element.cs_value)
                  }

                  if (element.cs_items != undefined) {
                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }
                  
                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items,
                caso,
                has_gd_integration
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                caso,
                has_gd_integration
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasoForAttention (v2_empresa_id,id) {

      var items = []
      var caso = {}
      var has_gd_integration = undefined

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getCasoForAttention", id: id } })
            .then(response => {

              if ( response.data ) {

                caso = response.data.caso
                has_gd_integration = response.data.has_gd_integration

                response.data.attributes.forEach(element => {

                  if (element.cs_column_name == "tiempo_acumulado") { 
                    element.cs_value = this.formatTimeToSeconds(element.cs_value)    
                  }

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDateTime(element.cs_value)
                  }

                  if (element.cs_items != undefined) {
                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }
                  
                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items,
                caso,
                has_gd_integration
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                caso,
                has_gd_integration
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasos_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('case_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('case_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('case_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })    
          }        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasoAtributos_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('case_atributes_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('case_atributes_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_atributos/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('case_atributes_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })    
          }        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasosFacturados_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('invoicedcases_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('invoicedcases_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getPrimaryAttributesFacturados" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('invoicedcases_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })      
          }    
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasosPorFacturar_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('invoicedPendientcases_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('invoicedPendientcases_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getPrimaryAttributesPorFacturar" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('invoicedPendientcases_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })      
          }    
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasoAtributos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_atributos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getHistorial (v2_empresa_id,data) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_historias/', { params: data })
              .then(response => {

                var items = response.data
                
                resolve({
                  items
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasoNotas (v2_empresa_id,data) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_notas/', { params: data })
              .then(response => {

                var items = response.data

                items.forEach(element => {
                  element.created_at = this.formatDateTime(element.created_at)
                });

                resolve({
                  items
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasos_DashboardAgent (v2_empresa_id,data) {
      
      var result = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {

            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: data })
              .then(response => {

                result.casos_por_atender = (response.data.casos_por_atender != undefined)?response.data.casos_por_atender:0;
                result.casos_cerrados = (response.data.casos_cerrados != undefined)?response.data.casos_cerrados:0;
                result.casos_recibidos = (response.data.casos_recibidos != undefined)?response.data.casos_recibidos:0;

                result.casos_por_atender_porcentaje = (response.data.casos_por_atender_porcentaje != undefined)?response.data.casos_por_atender_porcentaje:0;
                result.casos_cerrados_porcentaje = (response.data.casos_cerrados_porcentaje != undefined)?response.data.casos_cerrados_porcentaje:0;

                result.history_labels = response.data.history_labels
                result.history_values = response.data.history_values
                result.funnel_labels = response.data.funnel_labels
                result.funnel_sub_labels = response.data.funnel_sub_labels
                result.funnel_values = response.data.funnel_values

                response.data.funnel_values.forEach(element => {
                  var sum = element[0] + element[1] + element[2];
                  if (sum == 0) {
                    element[0] = 0.00000001;
                    element[1] = 0.00000001;
                    element[2] = 0.00000001;
                  }
                });

                resolve({
                  result
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  result
                })
                this.showError(error)
              })  
          } else {
            resolve({
              result
            })
            //this.showOK("")
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasos_Dashboard (v2_empresa_id,data) {
      
      var result = {}

      try {

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {

            ////this.updateProgress()
            
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_facturas/', { params: data })
              .then(response => {

                result.casos_por_atender = (response.data.casos_por_atender != undefined)?response.data.casos_por_atender:0;
                result.casos_por_facturar = (response.data.casos_por_facturar != undefined)?response.data.casos_por_facturar:0;
                result.casos_por_cobrar = (response.data.casos_por_cobrar != undefined)?response.data.casos_por_cobrar:0;
                result.casos_recibidos = (response.data.casos_recibidos != undefined)?response.data.casos_recibidos:0;
                result.casos_atendidos = (response.data.casos_atendidos != undefined)?response.data.casos_atendidos:0;

                result.casos_por_atender_porcentaje = (response.data.casos_por_atender_porcentaje != undefined)?response.data.casos_por_atender_porcentaje:0;
                result.casos_por_facturar_porcentaje = (response.data.casos_por_facturar_porcentaje != undefined)?response.data.casos_por_facturar_porcentaje:0;
                result.casos_por_cobrar_porcentaje = (response.data.casos_por_cobrar_porcentaje != undefined)?response.data.casos_por_cobrar_porcentaje:0;

                result.casos_por_atender_dinero = (response.data.casos_por_atender_dinero != undefined)?response.data.casos_por_atender_dinero:0.00;
                result.casos_por_facturar_dinero = (response.data.casos_por_facturar_dinero != undefined)?response.data.casos_por_facturar_dinero:0.00;
                result.casos_por_cobrar_dinero = (response.data.casos_por_cobrar_dinero != undefined)?response.data.casos_por_cobrar_dinero:0.00;

                result.casos_pagados_dinero = (response.data.casos_pagados_dinero != undefined)?response.data.casos_pagados_dinero:0.00;

                result.history_labels = response.data.history_labels
                result.history_values = response.data.history_values
                result.funnel_labels = response.data.funnel_labels
                result.funnel_sub_labels = response.data.funnel_sub_labels
                result.funnel_values = response.data.funnel_values

                response.data.funnel_values.forEach(element => {
                  var sum = element[0] + element[1] + element[2];
                  if (sum == 0) {
                    element[0] = 0.00000001;
                    element[1] = 0.00000001;
                    element[2] = 0.00000001;
                  }
                });

                result.casos_top_agentes = response.data.casos_top_agentes
                var cantidadAgentes = result.casos_top_agentes.length

                for (let index = 0; index < 5 - cantidadAgentes; index++) {
                  result.casos_top_agentes.push( {"id" : "fake_" + index, "text1" : "[sin datos]", "text2" : 0, "text3" : 0 })
                }

                if (response.data.tarifario_vigente.length == 0) {
                  //this.showError("Algunos datos no se podrán mostrar pues no hay un tarifario vigente")
                  //this.showOK("")
                }

                resolve({
                  result
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  result
                })
                this.showError(error)
              })  
          } else {
            resolve({
              result
            })
            //this.showOK("")
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasos_Dashboard_Lite (v2_empresa_id) {
      
      var result = []

      try {

        return new Promise((resolve, reject) => {

          var data = {}
          data.type = "getCasosDashboardLite"
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_facturas/', { params: data })
            .then(response => {

              result.push({
                id: 0,
                value: ((response.data.moneda)?(response.data.moneda.simbol):('')) + ' ' + this.formatMoney(response.data.casos_por_atender_dinero),
                text: 'Pendientes (' + ((response.data.casos_por_atender)?(response.data.casos_por_atender):(0)) + ')',
              })

              result.push({
                id: 1,
                value: ((response.data.moneda)?(response.data.moneda.simbol):('')) + ' ' + this.formatMoney(response.data.casos_por_facturar_dinero),
                text: 'Por Facturar (' + ((response.data.casos_por_facturar)?(response.data.casos_por_facturar):(0)) + ')',
              })

              result.push({
                id: 2,
                value: ((response.data.moneda)?(response.data.moneda.simbol):('')) + ' ' + this.formatMoney(response.data.casos_por_cobrar_dinero),
                text: 'Por Cobrar (' + ((response.data.casos_por_cobrar)?(response.data.casos_por_cobrar):(0)) + ')',
              })

              resolve({
                result
              })
              
            })
            .catch(error => {
              resolve({
                result
              })
              this.showError(error)
            })  
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasos_Dashboard_Invoice_Lite (v2_empresa_id) {
      
      var result = []

      try {

        return new Promise((resolve, reject) => {

          var data = {}
          data.type = "getCasosDashboardLite"
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_facturas/', { params: data })
            .then(response => {

              result.push({
                id: 0,
                value: ((response.data.moneda)?(response.data.moneda.simbol):('')) + ' ' + this.formatMoney(response.data.casos_por_facturar_dinero),
                text: 'Por Facturar (' + ((response.data.casos_por_facturar)?(response.data.casos_por_facturar):(0)) + ')',
              })

              result.push({
                id: 1,
                value: ((response.data.moneda)?(response.data.moneda.simbol):('')) + ' ' + this.formatMoney(response.data.casos_por_cobrar_dinero),
                text: 'Por Cobrar (' + ((response.data.casos_por_cobrar)?(response.data.casos_por_cobrar):(0)) + ')',
              })

              resolve({
                result
              })
              
            })
            .catch(error => {
              resolve({
                result
              })
              this.showError(error)
            })  
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasosTransferidosRelacionados (v2_empresa_id,v2_caso_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {

            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getCasosTransferidosRelacionados", caso_original_id: v2_caso_id } })
              .then(response => {

                var items = response.data.casos

                items.forEach(element => {
                  element.fecha = this.formatDateTime(element.fecha)
                });
                
                resolve({
                  items
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* CUOTAS */

    getCuotas_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('cuotas_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('cuotas_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_cuotas/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('cuotas_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })    
          }        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCuotas_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_cuotas/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEstadosCuotas () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_estado_cuotas/', { params: { type: "getEstados" } })
            .then(response => {

              if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.id, label: element.name })
                });
              }
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCuotaForUpdate (v2_empresa_id,id) {

      var cuota = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_cuotas/', { params: { type: "getCuotaForUpdate", id: id } })
            .then(response => {

              if ( response.data) {
                if ( response.data.length > 0 ) {
                  cuota = response.data[0]
                  cuota.fecha_emision = this.formatDateForInput(response.data[0].fecha_emision)
                  cuota.fecha_vencimiento = this.formatDateForInput(response.data[0].fecha_vencimiento) 
                  cuota.created_at = this.formatDateTime(response.data[0].created_at) 
                  cuota.updated_at = this.formatDateTime(response.data[0].updated_at) 
                }
              }

              resolve({
                cuota
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                cuota
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCuotaForView (v2_empresa_id,id) {

      var cuota = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_cuotas/', { params: { type: "getCuotaForView", id: id } })
            .then(response => {

              if ( response.data) {
                if ( response.data.length > 0 ) {
                  cuota = response.data[0]
                  cuota.fecha_emision = this.formatDateForInput(response.data[0].fecha_emision)
                  cuota.fecha_vencimiento = this.formatDateForInput(response.data[0].fecha_vencimiento) 
                  cuota.created_at = this.formatDateTime(response.data[0].created_at) 
                  cuota.updated_at = this.formatDateTime(response.data[0].updated_at) 
                }
              }

              resolve({
                cuota
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                cuota
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* PAGOS */

    getPagos_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('pagos_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('pagos_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_cuota_pagos/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('pagos_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })    
          }        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getPagos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_cuota_pagos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEstadosPagos () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_estado_pagos/', { params: { type: "getEstados" } })
            .then(response => {

              if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.id, label: element.name })
                });
              }
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getPagoForUpdate (v2_empresa_id,id) {

      var pago = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_cuota_pagos/', { params: { type: "getPagoForUpdate", id: id } })
            .then(response => {

              if ( response.data) {
                if ( response.data.length > 0 ) {
                  pago = response.data[0]
                  pago.fecha_emision = this.formatDateForInput(response.data[0].fecha_emision)
                  pago.fecha_vencimiento = this.formatDateForInput(response.data[0].fecha_vencimiento) 
                  pago.created_at = this.formatDateTime(response.data[0].created_at) 
                  pago.updated_at = this.formatDateTime(response.data[0].updated_at) 
                }
              }

              resolve({
                pago
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                pago
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },


    getCasoAtributosForUpdate (v2_empresa_id,id) {

      var entidad = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_atributos/', { params: { type: "getCasoAtributosForUpdate", id: id } })
            .then(response => {

              if ( response.data) {
                if ( response.data.length > 0 ) {
                  entidad = response.data[0]
                }
              }

              resolve({
                entidad
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                entidad
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCamposDisponibles (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_atributos/', { params: { type: "getCamposDisponibles" } })
            .then(response => {

              if ( response.data) {
                items = response.data
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReportEntidadesPorEmpresa (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reportes/', { params: { type: "getReportEntidadesPorEmpresa" } })
            .then(response => {

              if ( response.data) {
                items = response.data
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReportesPorEmpresa (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reportes/', { params: { type: "getReportesPorEmpresa" } })
            .then(response => {

              if ( response.data) {
                items = response.data
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReporteFiltrosForView (reporte_id,v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reporte_filtros/', { params: { type: "getReporteFiltrosForView", reporte_id: reporte_id } })
            .then(response => {

              if ( response.data ) {

                response.data.forEach(element => {

                  if (element.cs_items != undefined) {

                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }

                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              /*if ( response.data) {
                items = response.data
              }*/

              resolve({
                items
              })
              //this.showOK("")                
              
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReporteForUpdate (id, v2_empresa_id) {

      var reporte = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reportes/', { params: { type: "getReporteForUpdate", id: id } })
            .then(response => {
              
              reporte = response.data[0]
              reporte.created_at = this.formatDateTime(response.data[0].created_at) 
              reporte.updated_at = this.formatDateTime(response.data[0].updated_at) 
              
              resolve({
                reporte
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                reporte
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReportes_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('report_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('report_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reportes/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('report_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })            
          }   
        })
      } catch (error) {
        this.showError(error)
      }
    },
    
    getReportes_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reportes/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReporte_Viewer (v2_empresa_id, data) {

      var result = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reportes/', { params: data })
              .then(response => {

                result = response.data
                resolve({
                  result
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  result
                })
                this.showError(error)
              })  
          } else {
            resolve({
              result
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReportFilterCamposDisponibles (reporte_id, v2_empresa_id) {

      var items = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reporte_filtros/', { params: { type: "getReportFilterCamposDisponibles", reporte_id: reporte_id } })
            .then(response => {
              
              items = response.data 
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReporteFiltros (v2_reporte_id,v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reporte_filtros/', { params: { v2_reporte_id: v2_reporte_id } }) 
              .then(response => {

                var items = response.data

                resolve({
                  items
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReportCamposDisponibles (reporte_id, v2_empresa_id) {

      var items = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reporte_campos/', { params: { type: "getReportCamposDisponibles", reporte_id: reporte_id } })
            .then(response => {
              
              items = response.data 
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReport_CamposDisponibles (v2_empresa_id) {

      var items = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reportes/', { params: { type: "getCamposDisponibles" } })
            .then(response => {
              
              items = response.data 
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getReporteCampos (v2_reporte_id,v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_reporte_campos/', { params: { v2_reporte_id: v2_reporte_id } }) 
              .then(response => {

                var items = response.data

                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getPagoForView (v2_empresa_id,id) {

      var pago = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_cuota_pagos/', { params: { type: "getPagoForView", id: id } })
            .then(response => {

              if ( response.data) {
                if ( response.data.length > 0 ) {
                  pago = response.data[0]
                  pago.fecha_emision = this.formatDateForInput(response.data[0].fecha_emision)
                  pago.fecha_vencimiento = this.formatDateForInput(response.data[0].fecha_vencimiento) 
                  pago.created_at = this.formatDateTime(response.data[0].created_at) 
                  pago.updated_at = this.formatDateTime(response.data[0].updated_at) 
                }
              }

              resolve({
                pago
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                pago
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* CONTACTOS */

    getContactoForCreate (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_contactos/', { params: { type: "getContactoForCreate" } })
            .then(response => {

              if ( response.data ) {

                response.data.forEach(element => {

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDatetimeForInput(element.cs_value)
                  }

                  if (element.cs_items != undefined) {

                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }

                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              //this.showError(error)
            })           
        })
      } catch (error) {
        //this.showError(error)
      }
    },

    getContactoForUpdate (v2_empresa_id,id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_contactos/', { params: { type: "getContactoForUpdate", id: id } })
            .then(response => {

              if ( response.data ) {

                response.data.forEach(element => {

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDateTime(element.cs_value)
                  }

                  if (element.cs_items != undefined) {
                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }
                  
                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getContactoForView (v2_empresa_id,id) {

      var items = []
      var contacto = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_contactos/', { params: { type: "getContactoForView", id: id } })
            .then(response => {

              if ( response.data ) {

                contacto = response.data.contacto

                response.data.attributes.forEach(element => {

                  if (element.cs_column_name == "tiempo_acumulado") { 
                    element.cs_value = this.formatTimeToSeconds(element.cs_value)    
                  }

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDateTime(element.cs_value)
                  }

                  if (element.cs_items != undefined) {
                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }
                  
                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items,
                contacto
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                contacto
              })
              this.showError(error)
            })    
         
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getContactos_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('contact_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('contact_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_contactos/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('contact_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })            
          }  
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getContactos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_contactos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getContactoTelefonos (v2_empresa_id,v2_contact_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_contactos/'+ v2_contact_id +'/v2_contacto_telefonos/', { params: { type: "getTelefonosContacto" } })
            .then(response => {

              if ( response.data ) {

                items = response.data

              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getTiempoUsuarioHoy (data) {

      var tiempo = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/all/v2_caso_tiempos/', { params: data })
            .then(response => {
              if ( response.data ) {
                if ( response.data.length > 0 ) {
                  tiempo = response.data[0].tiempo  
                }
              }
              resolve({
                tiempo
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                tiempo
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasoTiempos_Headers  (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('caso_tiempos_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('caso_tiempos_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_tiempos/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('caso_tiempos_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })            
          }  
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasoTiempos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_caso_tiempos/', { params: data })
              .then(response => {

                var items = response.data.data

                items.forEach(element => {
                  element.tiempo = this.formatTimeToSeconds(element.tiempo)  
                });
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    

    /*getContactos_Headers () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/all/v2_contactos/', { params: { type: "getPrimaryAttributes" } })
            .then(response => {
              
              items = response.data

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getContactos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/all/v2_contactos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getContactoForUpdate (id) {

      var entidad = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/all/v2_contactos/', { params: { type: "getContacto", id: id } })
            .then(response => {
              
              entidad = response.data[0]
              entidad.created_at = this.formatDateTime(response.data[0].created_at) 
              entidad.updated_at = this.formatDateTime(response.data[0].updated_at) 
              
              resolve({
                entidad
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                entidad
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },*/

    /* COMBOS */

    getProductosPorEmpresa (v2_empresa_id) {

      var items = []

      try {

        ////this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_productos/', { params: { type: "getProductosPorEmpresa", searchQuery: '' } })
            .then(response => {

              if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.id, label: element.name })
                });
              }
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getProductosYPrecios (v2_empresa_id, v2_tarifario_id) {
      var items = []

      try {

        ////this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifarios/', { params: { type: "getProductosYPrecios", v2_tarifario_id: v2_tarifario_id } })
            .then(response => {

              items = response.data
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getProductoYPrecio (v2_empresa_id, v2_tarifario_id, v2_producto_id) {
      var producto = []

      try {

        ////this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifarios/', { params: { type: "getProductoYPrecio", v2_tarifario_id: v2_tarifario_id, v2_producto_id: v2_producto_id } })
            .then(response => {

              producto = response.data
              
              resolve({
                producto
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                producto
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEstadosPorEmpresa (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_estado_casos/', { params: { type: "getEstadosPorEmpresa" } })
            .then(response => {

              if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.id, label: element.name })
                });
              }
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },
    getEstadosPorEmpresaFilter (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_estado_casos/', { params: { type: "getEstadosPorEmpresaFilter" } })
            .then(response => {

              items = response.data

              /*if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.id, label: element.name })
                });
              }*/
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },
    getEstadosFacturaPorEmpresaFilter (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_estado_facturas/', { params: { type: "getEstadosPorEmpresaFilter" } })
            .then(response => {

              items = response.data

              /*if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.id, label: element.name })
                });
              }*/
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getUsuariosPorEmpresa (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_usuario_empresas/', { params: { type: "getUsuariosPorEmpresa", v2_empresa_id: v2_empresa_id } })
            .then(response => {

              if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.id, label: element.name })
                });
              }
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* AMBIENTES */

    getAmbientes_Headers () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('environment_headers') != undefined) {

            items = JSON.parse(localStorage.getItem('environment_headers'))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_environments/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('environment_headers', JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })           
          }  
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getAmbientes_rows (data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_environments/', { params: data })
            .then(response => {

              var items = response.data.data
              var total = response.data.count
              resolve({
                items,
                total
              })
              
              resolve({
                items,
                total
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                total
              })
              this.showError(error)
            })  
        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEnvironmentForUpdate (id) {  

      var environment = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get(`/desk/client/v1/v2_environments/${id}`)
            .then(response => {
              
              environment = response.data
              environment.created_at = this.formatDateTime(response.data.created_at) 
              environment.updated_at = this.formatDateTime(response.data.updated_at) 
              
              resolve({
                environment
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                environment
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEnvironmentForView (id) {  

      var environment = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get(`/desk/client/v1/v2_environments/${id}`)
            .then(response => {
              
              environment = response.data
              environment.created_at = this.formatDateTime(response.data.created_at) 
              environment.updated_at = this.formatDateTime(response.data.updated_at) 
              
              resolve({
                environment
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                environment
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* ROLES */

    getRoles_Headers () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if (localStorage.getItem('rol_headers') != undefined) {

            items = JSON.parse(localStorage.getItem('rol_headers'))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/auth/v1/roles/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('rol_headers', JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })    
          }         
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getRoles_rows (data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/auth/v1/roles/', { params: data })
            .then(response => {

              var items = response.data.data
              var total = response.data.count
              resolve({
                items,
                total
              })
              
              resolve({
                items,
                total
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                total
              })
              this.showError(error)
            })  
        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getRolForUpdate (id) {  

      var rol = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get(`/auth/v1/roles/${id}`)
            .then(response => {
              
              rol = response.data
              rol.created_at = this.formatDateTime(response.data.created_at) 
              rol.updated_at = this.formatDateTime(response.data.updated_at) 
              
              resolve({
                rol
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                rol
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getRolForView (id) {  

      var rol = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get(`/auth/v1/roles/${id}`)
            .then(response => {
              
              rol = response.data
              rol.created_at = this.formatDateTime(response.data.created_at) 
              rol.updated_at = this.formatDateTime(response.data.updated_at) 
              
              resolve({
                rol
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                rol
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getPermisosDelRol (id, scope) {
      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          this.$http.secured.get('/auth/v1/roles/', { params: { type: "getPermisosDelRol", id: id, scope: scope } })
            .then(response => {

              items = response.data

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getTipoPermisos () {
      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('tipo_permisos') != undefined) {

            items = JSON.parse(localStorage.getItem('tipo_permisos'))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/auth/v1/v3_permission_types/', { params: { type: "getTipoPermisos" } })
              .then(response => {

                items = response.data

                localStorage.setItem('tipo_permisos', JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          }   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getModeloPermisos () {
      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('modelo_permisos') != undefined) {

            items = JSON.parse(localStorage.getItem('modelo_permisos'))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/auth/v1/v3_permission_models/', { params: { type: "getModeloPermisos", scope: 'desk' } })
              .then(response => {

                items = response.data

                localStorage.setItem('modelo_permisos', JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })  
          }   
                    
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getAccesosNoAsignados () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_accesos/', { params: { type: "showaccesosall" } })
            .then(response => {
              
              items = response.data
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getAccesosAsignados (id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_accesos/', { params: { type: "showaccesosbyrol", id: id } })
            .then(response => {

              response.data.forEach(element => {
                items.push(element.id)
              });
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* ACCESOS */

    getAccesos_Headers () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('access_headers') != undefined) {

            items = JSON.parse(localStorage.getItem('access_headers'))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_accesos/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('access_headers', JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })    
          }  
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getAccesos_rows (data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_accesos/', { params: data })
            .then(response => {

              var items = response.data.data
              var total = response.data.count
              resolve({
                items,
                total
              })
              
              resolve({
                items,
                total
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                total
              })
              this.showError(error)
            })  
        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getAccesoForUpdate (id) {  

      var acceso = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get(`/desk/client/v1/v2_accesos/${id}`)
            .then(response => {
              
              acceso = response.data
              acceso.created_at = this.formatDateTime(response.data.created_at) 
              acceso.updated_at = this.formatDateTime(response.data.updated_at) 
              
              resolve({
                acceso
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                acceso
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* GOOGLE DRIVE */

    getRepositoriosPorEmpresa (data) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          this.$http.secured.get('/global/v1/v2_repositorios/', { params: data })
            .then(response => {

              var items = response.data.data
              resolve({
                items
              })
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })  
        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getGoogleDrive_Headers () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('drive_headers') != undefined) {

            items = JSON.parse(localStorage.getItem('drive_headers'))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/global/v1/v2_repositorios/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('drive_headers', JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })       
          }  
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getGoogleDrive_rows (data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          this.$http.secured.get('/global/v1/v2_repositorios/', { params: data })
            .then(response => {

              var items = response.data.data
              var total = response.data.count
              resolve({
                items,
                total
              })
              
              resolve({
                items,
                total
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                total
              })
              this.showError(error)
            })  
        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getGoogleDriveForUpdate (id) {

      var googledrive = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/global/v1/v2_repositorios/', { params: { type: "getGoogleDriveForUpdate", id: id } })
            .then(response => {
              
              googledrive = response.data[0]
              googledrive.created_at = this.formatDateTime(response.data[0].created_at) 
              googledrive.updated_at = this.formatDateTime(response.data[0].updated_at) 
              
              resolve({
                googledrive
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                googledrive
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getGoogleDriveForView (id, v2_empresa_id) {

      var googledrive = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/global/v1/v2_repositorios/', { params: { type: "getGoogleDriveForView", id: id, v2_empresa_id: v2_empresa_id } })
            .then(response => {
              
              googledrive = response.data[0]
              googledrive.fecha_de_creación = this.formatDateTime(response.data[0].fecha_de_creación) 
              googledrive.fecha_de_actualización = this.formatDateTime(response.data[0].fecha_de_actualización) 
              
              resolve({
                googledrive
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                googledrive
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* EMPRESAS */

    getEmpresas_Headers () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('company_headers') != undefined) {

            items = JSON.parse(localStorage.getItem('company_headers'))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('company_headers', JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })     
          }         
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEmpresas_rows (data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/', { params: data })
            .then(response => {

              var items = response.data.data
              var total = response.data.count
              resolve({
                items,
                total
              })
              
              resolve({
                items,
                total
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                total
              })
              this.showError(error)
            })  
        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEmpresaForUpdate (id) {

      var empresa = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get(`/desk/client/v1/v2_empresas/${id}`)
            .then(response => {
              empresa = response.data
              empresa.created_at = this.formatDateTime(response.data.created_at) 
              empresa.updated_at = this.formatDateTime(response.data.updated_at) 
              
              resolve({
                empresa
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                empresa
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEmpresaForView (id) {

      var empresa = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/', { params: { type: "getEmpresaForView", id: id } })
            .then(response => {
              empresa = response.data[0]
              empresa.created_at = this.formatDateTime(response.data[0].created_at) 
              empresa.updated_at = this.formatDateTime(response.data[0].updated_at) 
              
              resolve({
                empresa
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                empresa
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* CONTRATOS */

    getContratos_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('contract_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('contract_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/all/v2_contratos/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('contract_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })           
          }   
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getContratos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/all/v2_contratos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getContratoForUpdate (id) {

      var caso = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/all/v2_contratos/', { params: { type: "getContrato", id: id } })
            .then(response => {
              
              caso = response.data[0]
              caso.fecha_inicio = this.formatDateForInput(response.data[0].fecha_inicio) 
              caso.fecha_fin = this.formatDateForInput(response.data[0].fecha_fin) 
              caso.created_at = this.formatDateTime(response.data[0].created_at) 
              caso.updated_at = this.formatDateTime(response.data[0].updated_at) 
              
              resolve({
                caso
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                caso
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* PRODUCTOS */

    getProductoForCreate (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_productos/', { params: { type: "getProductoForCreate" } })
            .then(response => {

              if ( response.data ) {

                response.data.forEach(element => {

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDatetimeForInput(element.cs_value)
                  }

                  if (element.cs_items != undefined) {

                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }

                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getProductoForUpdate (v2_empresa_id,id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_productos/', { params: { type: "getProductoForUpdate", id: id } })
            .then(response => {

              if ( response.data ) {

                response.data.forEach(element => {

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDateTime(element.cs_value)
                  }

                  if (element.cs_items != undefined) {
                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }
                  
                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getProductoForView (v2_empresa_id,id) {

      var items = []
      var producto = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_productos/', { params: { type: "getProductoForView", id: id } })
            .then(response => {

              if ( response.data ) {

                producto = response.data.producto

                response.data.attributes.forEach(element => {

                  if (element.cs_column_name == "tiempo_acumulado") { 
                    element.cs_value = this.formatTimeToSeconds(element.cs_value)    
                  }

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }

                  if (element.cs_type == "datetime-local") { 
                    element.cs_value = this.formatDateTime(element.cs_value)
                  }

                  if (element.cs_items != undefined) {
                    if (element.cs_items.length > 0) {
                      
                      var items_formated = []
                      var items_split = element.cs_items.split("|")
  
                      items_split.forEach(i => {
                        items_formated.push({ "id" : i, "label" : i })
                      });
  
                      element.cs_items = items_formated
                    }
                  }

                  if (element.cs_type == "date") { 
                    element.cs_value = this.formatDateForInput(element.cs_value)
                  }
                  
                  items.push(element)
                });

                items.sort(function(a, b){return a.cs_order-b.cs_order})
              }

              resolve({
                items,
                producto
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                producto
              })
              this.showError(error)
            })    
         
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getProductos_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('product_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('product_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_productos/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('product_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })    
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getProductos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_productos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* MIS CASOS */

    getMisCasos_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('mycases_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('mycases_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { type: "getPrimaryAttributesMiBandeja" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('mycases_headers_' + v2_empresa_id, JSON.stringify(items));
            
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })   
          }         
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getMisCasos_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count

                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* USUARIOS */

    getUsuarios_Headers () {

      var items = []
      var auth_only_email = ''

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('user_headers') != undefined) {

            items = JSON.parse(localStorage.getItem('user_headers'))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/auth/v1/users/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data.headers
                //auth_only_email = response.data.auth_only_email

                localStorage.setItem('user_headers', JSON.stringify(items));

                resolve({
                  items,
                  auth_only_email
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  auth_only_email
                })
                this.showError(error)
              })           
          }   
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getUsuarios_rows (data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          

          this.$http.secured.get('/auth/v1/users/', { params: data })
            .then(response => {

              var items = response.data.data
              var total = response.data.count
              resolve({
                items,
                total
              })
              
              resolve({
                items,
                total
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items,
                total
              })
              this.showError(error)
            })  
        
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getUsuarioForUpdate (id) {

      var usuario = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get(`/auth/v1/users/${id}`)
            .then(response => {
              
              usuario = response.data
              //usuario.received_at = new Date(moment(String(response.data.received_at)).format('YYYY-MM-DD')).toISOString().slice(0,10)
              
              resolve({
                usuario
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                usuario
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getUsuarioForView (id) {

      var usuario = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get(`/auth/v1/users/${id}`)
            .then(response => {
              
              usuario = response.data
              //usuario.received_at = new Date(moment(String(response.data.received_at)).format('YYYY-MM-DD')).toISOString().slice(0,10)
              
              resolve({
                usuario
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                usuario
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getRolesAsignados (v2_usuario_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/auth/v1/roles/', { params: { type: "getRolesDeUsuario", id: v2_usuario_id } })
            .then(response => {

              items = response.data
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getRolesNoAsignados () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/auth/v1/roles/', { params: { type: "getRolesSelect" } })
            .then(response => {

              items = response.data
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEmpresasNoAsignadas () {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/', { params: { type: "getMisEmpresasAdminSelect" } })
            .then(response => {

              if ( response.data ) {
                items = response.data
              }
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEmpresasAsignadas (v2_usuario_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_usuario_empresas', { params: { type: "getEmpresasByUsuarioSelect", id: v2_usuario_id } })
            .then(response => {

              if ( response.data ) {
                items = response.data
              }
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    /* TARIFARIOS */

    getTarifarios_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('rate_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('rate_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifarios/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('rate_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })            
          }   
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getTarifarios_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifarios/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getTarifarioForUpdate (id, v2_empresa_id) {

      var tarifario = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifarios/', { params: { type: "getTarifarioForUpdate", id: id } })
            .then(response => {
              
              tarifario = response.data[0]
              tarifario.vigencia_inicio = this.formatDateForInput(response.data[0].vigencia_inicio)
              tarifario.vigencia_fin = this.formatDateForInput(response.data[0].vigencia_fin) 
              tarifario.created_at = this.formatDateTime(response.data[0].created_at) 
              tarifario.updated_at = this.formatDateTime(response.data[0].updated_at) 
              
              resolve({
                tarifario
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                tarifario
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getTarifarioForView (id, v2_empresa_id) {

      var tarifario = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifarios/', { params: { type: "getTarifarioForView", id: id } })
            .then(response => {

              tarifario = response.data[0]
              tarifario.inicio_de_vigencia = this.formatDateForInput(response.data[0].inicio_de_vigencia) 
              tarifario.fin_de_vigencia = this.formatDateForInput(response.data[0].fin_de_vigencia) 
              tarifario.created_at = this.formatDateTime(response.data[0].created_at) 
              tarifario.updated_at = this.formatDateTime(response.data[0].updated_at) 
              
              resolve({
                tarifario
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                tarifario
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getTarifariosVigentesPorEmpresa (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifarios/', { params: { type: "getTarifariosVigentesPorEmpresa" } })
            .then(response => {

              if ( response.data ) {
                response.data.forEach(element => {
                  items.push({ id: element.id, label: element.name })
                });
              }
              
              resolve({
                items
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                items
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },


    /* TARIFARIO DETALLE 

    getTarifarioDetalles_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('ratedetail_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('ratedetail_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifario_detalles/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('ratedetail_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })        
          }   
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getTarifarioDetalles_rows (v2_empresa_id,id) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_tarifario_detalles/', { params: { type: "getTarifasPorTarifario", id: id } })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },*/

    /* FACTURA */

    getFacturas_Headers (v2_empresa_id) {

      var items = []

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {

          if (localStorage.getItem('invoice_headers_' + v2_empresa_id) != undefined) {

            items = JSON.parse(localStorage.getItem('invoice_headers_' + v2_empresa_id))
            resolve({
              items
            }) 
            
          } else {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_facturas/', { params: { type: "getPrimaryAttributes" } })
              .then(response => {
                
                items = response.data

                localStorage.setItem('invoice_headers_' + v2_empresa_id, JSON.stringify(items));
                
                resolve({
                  items
                })
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items
                })
                this.showError(error)
              })     
          }   
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getFacturas_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_facturas/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getFacturaForUpdate (id, v2_empresa_id) {

      var factura = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_facturas/', { params: { type: "getFacturaForUpdate", id: id } })
            .then(response => {
              
              factura = response.data[0]
              factura.fecha_emision = this.formatDateForInput(response.data[0].fecha_emision)
              factura.fecha_vencimiento = this.formatDateForInput(response.data[0].fecha_vencimiento) 
              factura.created_at = this.formatDateTime(response.data[0].created_at) 
              factura.updated_at = this.formatDateTime(response.data[0].updated_at) 

              resolve({
                factura
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                factura
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getFacturaForView (id, v2_empresa_id) {

      var factura = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_facturas/', { params: { type: "getFacturaForView", id: id } })
            .then(response => {
              
              factura = response.data[0]
              factura.fecha_emision = this.formatDateForInput(response.data[0].fecha_emision)
              factura.fecha_vencimiento = this.formatDateForInput(response.data[0].fecha_vencimiento) 
              factura.created_at = this.formatDateTime(response.data[0].created_at) 
              factura.updated_at = this.formatDateTime(response.data[0].updated_at) 

              resolve({
                factura
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                factura
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEnvironmentInvoiceData () {

      var data = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/all/v2_facturas/', { params: { type: "getEnvironmentInvoiceData" } })
            .then(response => {
              
              data = response.data

              resolve({
                data
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                data
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getEmpresaInvoiceData (v2_empresa_id) {

      var data = {}

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          this.$http.secured.get('/desk/client/v1/v2_empresas/', { params: { type: "getEmpresaInvoiceData", id: v2_empresa_id } })
            .then(response => {
              
              data = response.data

              resolve({
                data
              })
              //this.showOK("")
            })
            .catch(error => {
              resolve({
                data
              })
              this.showError(error)
            })           
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasosPorFacturar_rows (v2_empresa_id,data) {

      var items = []
      var total = 0

      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: data })
              .then(response => {

                var items = response.data.data
                var total = response.data.count
                resolve({
                  items,
                  total
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  items,
                  total
                })
                this.showError(error)
              })  
          } else {
            resolve({
              items,
              total
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },

    getCasosFacturadosAll_rows  (v2_empresa_id, v2_factura_id) { 
 
      var items = []
 
      try { 
 
        //this.updateProgress() 
 
        return new Promise((resolve, reject) => { 
           
          if ( v2_empresa_id > 0 ) { 
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: { v2_factura_id: v2_factura_id, type: "getCasosFacturadosAll" } }) 
              .then(response => { 
 
                var items = response.data.data 
                resolve({ 
                  items
                }) 
                 
                resolve({ 
                  items 
                }) 
                //this.showOK("") 
              }) 
              .catch(error => { 
                resolve({ 
                  items 
                }) 
                this.showError(error) 
              })   
          } else { 
            resolve({ 
              items
            }) 
          }  
        }) 
      } catch (error) { 
        resolve({ 
          items 
        }) 
        this.showError(error) 
      } 
    }, 

    getCasosFacturadosDetail_rows (v2_empresa_id,data) { 
 
      var items = [] 
      var total = 0 
 
      try { 
 
        //this.updateProgress() 
 
        return new Promise((resolve, reject) => { 
           
          if ( v2_empresa_id > 0 ) { 
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: data }) 
              .then(response => { 
 
                var items = response.data.data 
                var total = response.data.count 
                resolve({ 
                  items, 
                  total 
                }) 
                 
                resolve({ 
                  items, 
                  total 
                }) 
                //this.showOK("") 
              }) 
              .catch(error => { 
                resolve({ 
                  items, 
                  total 
                }) 
                this.showError(error) 
              })   
          } else { 
            resolve({ 
              items, 
              total 
            }) 
          }  
        }) 
      } catch (error) { 
        resolve({ 
          items 
        }) 
        this.showError(error) 
      } 
    }, 

    getCasosFacturados_rows (v2_empresa_id,data) {

      var valor = {}
      
      try {

        //this.updateProgress()

        return new Promise((resolve, reject) => {
          
          if ( v2_empresa_id > 0 ) {
            this.$http.secured.get('/desk/client/v1/v2_empresas/'+ v2_empresa_id +'/v2_casos/', { params: data })
              .then(response => {

                valor = response.data
                resolve({
                  valor
                })
                
                //this.showOK("")
              })
              .catch(error => {
                resolve({
                  valor
                })
                this.showError(error)
              })  
          } else {
            resolve({
              valor
            })
          } 
        })
      } catch (error) {
        this.showError(error)
      }
    },


  }
};